document.addEventListener("DOMContentLoaded", () => {
  if (!window.location.pathname.startsWith("/collections/")) {
    return; // Exit if not on a collection page
  }

  const modal = document.querySelector(".quick-view-modal");
  const closeIcon = modal.querySelector(".quick-view-modal__close-icon");
  const spinner = modal.querySelector(".quick-view-modal__spinner-wrapper");
  const productDetailsWrapper = modal.querySelector(".modal-product__wrapper");
  let currentVariantId = null;

  // Function to fetch product data
  async function fetchProductData(handle) {
    try {
      spinner.style.display = "block";
      productDetailsWrapper.style.display = "none";
      const response = await fetch(`/products/${handle}.js`);
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product data:", error);
      return null;
    } finally {
      spinner.style.display = "none";
      productDetailsWrapper.style.display = "flex";
    }
  }

  // Function to populate modal content
  function populateModal(product) {
    const imageElement = modal.querySelector(".modal-product__image");
    const placeholder = modal.querySelector(".image-placeholder");

    // Show the placeholder initially
    placeholder.style.display = "flex";
    imageElement.style.display = "none";

    // Set product details
    modal.querySelector(".modal-product__title").textContent = product.title;
    modal.querySelector(".modal-product__price span").textContent = formatMoney(product.price, "{{amount_with_currency}}");
    modal.querySelector(".modal-product__sku span").textContent = product.variants[0].sku || "N/A";
    modal.querySelector(".modal-product__vendor span").textContent = product.vendor || "Unknown";
    currentVariantId = product.variants[0].id;

    // Reset quantity
    modal.querySelector("#product-quantity").value = 1;

    // Load the product image
    imageElement.src = product.featured_image || "/path-to-placeholder.jpg";
    imageElement.onload = () => {
      placeholder.style.display = "none"; // Hide placeholder once the image loads
      imageElement.style.display = "block"; // Show the image
    };
  }

  // Money Formatter
  function formatMoney(cents, format = "{{amount}}") {
    const amount = (cents / 100).toFixed(2); // Convert cents to dollars and ensure 2 decimals
    if (format === "{{amount}}") {
      return amount; // Return the plain amount
    }
    if (format === "{{amount_with_currency}}") {
      return `$${amount}`; // Add currency symbol (adjust as needed)
    }
    if (format === "{{amount_no_decimals}}") {
      return Math.round(cents / 100); // No decimals
    }
    return amount; // Default fallback
  }

  // Event handler for Quick View buttons
  document.body.addEventListener("click", async (e) => {
    if (e.target.closest(".quick-view-button")) {
      e.preventDefault();
      const button = e.target.closest(".quick-view-button");
      const handle = button.getAttribute("data-product-handle");

      // Show modal and fetch product data
      document.body.style.overflow = "hidden";
      modal.classList.add("active");
      const product = await fetchProductData(handle);
      if (product) populateModal(product);
    }
  });

  // Close modal
  closeIcon.addEventListener("click", () => {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  });

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.classList.remove("active");
      document.body.style.overflow = "";
    }
  });

  // Quantity controls
  modal.querySelector("#decrease-quantity").addEventListener("click", () => {
    const quantityInput = modal.querySelector("#product-quantity");
    if (parseInt(quantityInput.value, 10) > 1) {
      quantityInput.value = parseInt(quantityInput.value, 10) - 1;
    }
  });

  modal.querySelector("#increase-quantity").addEventListener("click", () => {
    const quantityInput = modal.querySelector("#product-quantity");
    quantityInput.value = parseInt(quantityInput.value, 10) + 1;
  });

  // Add to cart
  modal.querySelector(".quick-view-add-to-cart").addEventListener("click", async () => {
    const quantity = modal.querySelector("#product-quantity").value;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: currentVariantId, quantity }),
      });

      if (!response.ok) {
        throw new Error("Failed to add product to cart");
      }

      // Refresh page after 1 second
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  });
});
